import { useEffect, useState } from "react";
import FlexRow from "../../../../../components/base/FlexRow";
import Icon from "../../../../../components/base/Icon";
import { PaymentTypes } from "../../../../../core/Enums";
import { canViewJobRates, editJobPaymentOpen, getUser, hasRole } from "../../../../../core/Global";
import Job from "../../models/Job";
import JobPaymentDetails from "../../models/JobPaymentDetails";
import { getPaymentTypeDetails } from "../../../../../core/Helper";


interface IProps {
    job: Job
}
export default function JobDrawerPayments(props: IProps) {

    const moneyFormatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
    });
    const user = getUser()
    // The technician sees the split of their own job here unless ViewJobRates is denied to them;
    // then they get the plain list of payments like the office.
    const showSplit = !!user?.isTech && canViewJobRates()
    const [model, modelSet] = useState<JobPaymentDetails>();

    useEffect(() => {
        modelSet(props.job.paymentDetails)
    }, [props.job.paymentDetails])

    useEffect(() => {
        if (showSplit && model) {
            var pieNumbers = [model.techProfit ?? 0, model.companyProfit ?? 0, model.sourceProfit ?? 0, model.totalParts ?? 0];
            var pieColors = ["#50cd89", "#ffc700", "#009ef7", "#7239ea"];
            window.createCircleChart("jobpaymentchart-circle", pieNumbers, pieColors);
        }
    }, [showSplit, model])

    return (
        <div className="">
            {
                showSplit && model ?
                    <>

                        <div className="">

                            <FlexRow justify="center" className="mb-10">
                                <div style={{
                                    position: "relative",
                                    width: 160,
                                    height: 160
                                }}>

                                    <div id="jobpaymentchart-circle" data-kt-size="160" data-kt-line="20"></div>

                                    <div style={{
                                        position: "absolute",
                                        top: 60,
                                        right: 0,
                                        width: 160,
                                        height: 160,
                                        textAlign: "center"
                                    }}>
                                        <div className="fs-1 fw-bolder text-center">
                                            {moneyFormatter.format(props.job.payment?.totalPaymentWithTax ?? 0)}
                                        </div>
                                        <div className="fs-7 text-center">
                                            Total
                                        </div>
                                    </div>
                                </div>
                            </FlexRow>

                            <div>
                                <FlexRow className="border-bottom pb-1 mb-3">
                                    <Icon icon="circle" type="solid" className={(model.techBalance ?? 0) < 0 ? "text-danger" : "text-success"} />
                                    <span className="ms-2">
                                        Balance
                                    </span>
                                    <span className={"ms-auto fs-3 fw-bold " + ((model.techBalance ?? 0) < 0 ? "text-danger" : "text-success")}>
                                        {
                                            model.techBalance && model.techBalance > 0 ?
                                                <>+</>
                                                : <></>
                                        }
                                        {moneyFormatter.format(model.techBalance ?? 0)}
                                    </span>
                                </FlexRow>
                                <FlexRow className="border-bottom pb-1 mb-3">
                                    <Icon icon="circle" type="solid" className="text-success me-2" />
                                    <span>
                                        My Profit ({model.techRate}%)
                                    </span>
                                    <span className="ms-auto fs-5">
                                        {moneyFormatter.format(model.techProfit ?? 0)}
                                    </span>
                                </FlexRow>

                                {/* <FlexRow className="border-bottom pb-1 mb-3">
                                    <Icon icon="circle" type="solid" className="text-primary me-2" />
                                    <span>
                                        Source Profit ({model.sourceRate}%)
                                    </span>
                                    <span className="ms-auto fs-5">
                                        {moneyFormatter.format(model.sourceProfit ?? 0)}
                                    </span>
                                </FlexRow>

                                <div className="border-bottom pb-1 mb-3">
                                    <FlexRow>
                                        <Icon icon="circle" type="solid" className="text-warning me-2" />
                                        <span>
                                            Company Profit ({model.companyRate}%)
                                        </span>
                                        <span className="ms-auto fs-5">
                                            {moneyFormatter.format(model.companyProfit ?? 0)}
                                        </span>
                                    </FlexRow>
                                    <FlexRow className="ms-3 mt-1 mb-1" justify="end">
                                        <span className="me-1 text-muted fs-8">
                                            Tech Fee:
                                        </span>
                                        <span className="text-muted fs-8">
                                            {moneyFormatter.format(model.techFee ?? 0)}
                                        </span>
                                    </FlexRow>
                                </div> */}


                                <div className="border-bottom pb-1 mb-3">
                                    <FlexRow>
                                        <Icon icon="circle" type="solid" className="text-info me-2" />
                                        <span>
                                            Costs
                                        </span>
                                        <span className="ms-auto fs-5">
                                            {moneyFormatter.format(model.totalParts ?? 0)}
                                        </span>
                                    </FlexRow>
                                    <FlexRow className="ms-3 mt-1 mb-1" justify="end">
                                        <span className="me-1 text-muted fs-8">
                                            Tech Parts:
                                        </span>
                                        <span className="text-muted fs-8">
                                            {moneyFormatter.format(model.techParts ?? 0)}
                                        </span>
                                    </FlexRow>
                                    <FlexRow className="ms-3 mt-1 mb-1" justify="end">
                                        <span className="me-1 text-muted fs-8">
                                            Company Parts:
                                        </span>
                                        <span className="text-muted fs-8">
                                            {moneyFormatter.format(model.companyParts ?? 0)}
                                        </span>
                                    </FlexRow>
                                </div>
                            </div>





                        </div>

                    </>
                    :
                    <>
                        <table className="table align-middle table-row-dashed fs-6 gy-5 mb-0">
                            <thead>
                                <tr className="border-bottom fs-7 fw-bolder text-muted">
                                    <th className="min-w-125px pb-2">Payment Type</th>
                                    <th className="min-w-70px pb-2">Amount</th>
                                    <th className="min-w-100px pb-2">Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    props.job.payment?.paymentItems?.map((p, k) =>
                                        <tr key={k}>
                                            <td className="fw-bolder">
                                                <FlexRow>
                                                    <div className="me-2">
                                                        <Icon icon={getPaymentTypeDetails(p.paymentType).icon}
                                                            type={getPaymentTypeDetails(p.paymentType).iconType} />
                                                    </div>
                                                    <div>
                                                        {getPaymentTypeDetails(p.paymentType).name}
                                                    </div>
                                                </FlexRow>
                                            </td>
                                            <td>
                                                {p.amount}$
                                            </td>
                                            <td>
                                                {
                                                    p.checkNumber &&
                                                    <div className="text-muted fs-7">
                                                        Check No# {p.checkNumber}
                                                    </div>
                                                }
                                                {
                                                    p.approval &&
                                                    <div className="text-muted fs-7">
                                                        Approval# {p.approval}
                                                    </div>
                                                }
                                                {
                                                    p.cancelFee &&
                                                    <div className="text-muted fs-7">
                                                        <Icon icon="info-circle" className="me-2" type="solid" />
                                                        Fee Canceled
                                                    </div>
                                                }
                                                {
                                                    p.paidToTech &&
                                                    <div className="text-muted fs-7">
                                                        Paid to Technician
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    )
                                }

                            </tbody>
                        </table>

                        <div className="text-end">
                            {
                                !user?.isTech && (!props.job?.isArchived || hasRole("EditArchivedJobs")) &&
                                <button type="button" className="btn btn-sm btn-dark" onClick={e => editJobPaymentOpen(props.job)}>
                                    <Icon icon="edit" />
                                    Edit Payment
                                </button>
                            }
                        </div>
                    </>
            }

        </div>
    )

}